import angular from 'angular';
import ngResource from 'angular-resource';

function ClioServ($resource) {
  return $resource(
    "/account/clio", {
      id: '@id'
    }, {
      'getFolder': {
        method: 'GET',
        url: '/account/clio/folder'
      },
      'getFile': {
        method: 'GET',
        url: '/account/clio/file'
      },
      'sync': {
        method: 'GET',
        url: '/account/clio/sync'
      },
      'userDisconnect': {
        method: 'DELETE',
        url: '/user/clio'
      },
      'disconnect': {
        method: 'DELETE'
      }
    }
  );
}
ClioServ.$inject = ['$resource'];

export default angular.module('services.clio', [ngResource])
  .factory('Clio', ClioServ)
  .name;



// WEBPACK FOOTER //
// ./project/services/clio.js